/* global  */ // tUrl等のグローバル変数を宣言する
import './_smoothScroll' // スムーズスクロール
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,.' + accBtn + '-close,#' + accBtn + ' a,#overlay,#' + accBtn + ' .js-modal--btn').on(
    'click',
    function() {
      $('#' + accBtn + ',#' + accBtn + '-open,.' + accBtn + '-close,#overlay').toggleClass('active')
      scrollLock('html,body', '#overlay')
    }
  )

  /*
    ######   ######          ##        #######   ######  ##    ##
   ##    ## ##    ##         ##       ##     ## ##    ## ##   ##
   ##       ##               ##       ##     ## ##       ##  ##
    ######  ##       ####### ##       ##     ## ##       #####
         ## ##               ##       ##     ## ##       ##  ##
   ##    ## ##    ##         ##       ##     ## ##    ## ##   ##
    ######   ######          ########  #######   ######  ##    ##
  */
  /**
   * Safariを含めた全ブラウザでスクロールをロックする
   * オーバーレイの状態を基準にONOFFを切り替え
   * scrollLock('html,body', '#overlay')
   *
   * @function scrollLock
   * @param  {String} [selecter='html,body']  固定対象セレクタ
   * @param  {String} [trigger='#overlay']  判定用セレクタ
   * @return {Boolean} false
   */
  let scrollTop
  function scrollLock(selecter = 'html,body', trigger = '#overlay') {
    if ($(trigger).hasClass('active')) {
      // スクロール停止
      scrollTop = $(window).scrollTop()
      $(selecter).css({ position: 'fixed', top: -scrollTop })
    } else {
      // スクロール停止解除
      $(selecter).css({ position: 'static', top: '0' })
      $(selecter).scrollTop(scrollTop)
    }
  }

  /*
        ######   ######  ########          ##     ## ########    ###    ########
       ##    ## ##    ## ##     ##         ##     ## ##         ## ##   ##     ##
       ##       ##       ##     ##         ##     ## ##        ##   ##  ##     ##
        ######  ##       ########  ####### ######### ######   ##     ## ##     ##
             ## ##       ##   ##           ##     ## ##       ######### ##     ##
       ##    ## ##    ## ##    ##          ##     ## ##       ##     ## ##     ##
        ######   ######  ##     ##         ##     ## ######## ##     ## ########
*/

  // スクロール量による切り替え要素　負荷を抑えるためFPS制で処理する
  const scToggleFps = 5 // 1秒間の判定回数 60FPSまで上げるとほとんど負荷低減効果がなくなる
  const scToggleFrameTime = 1000 / scToggleFps
  let scToggleIsScroll = false // スクロールフラグ
  let scToggleScrollY = 0 // 縦方向のスクロール量
  let scTogglePx = 500 // スクロール半定ライン
  const scToggleTarget = document.querySelectorAll('.js-half') // ターゲット要素
  const scToggleClass = 'half' // スイッチ用クラス
  let scToggleSwitch = false // ターゲット要素のONOFF状態

  // console.log(scToggleTarget)

  // 負荷テスト用
  // let scToggleScrollCount = 0
  // let scToggleSctionCount = 0
  document.addEventListener('scroll', function(ev) {
    // スクロール量の更新だけを行う
    scToggleScrollY = window.pageYOffset // スクロール量更新
    scToggleIsScroll = true // フラグON
    // console.log('Scroll:' + ++scToggleScrollCount)
  })
  scrollFadein()
  function scrollFadein() {
    // スクロールフラグが立っているときだけDOM書き換え
    if (scToggleIsScroll) {
      // モーダル展開中は処理しない
      if (!$('#modalOverlay').hasClass('active')) {
        if (scToggleScrollY >= scTogglePx && !scToggleSwitch) {
          //トップから指定px以上スクロールしたらON
          scToggleTarget[0].classList.add(scToggleClass)
          for (let i = 0; i < scToggleTarget.length; ++i) {
            scToggleTarget[i].classList.add(scToggleClass)
          }
          // console.log('Action:' + ++scToggleSctionCount)
          scToggleSwitch = true
        } else if (scToggleScrollY < scTogglePx && scToggleSwitch) {
          //スクロールが足りない時はOFF
          for (let i = 0; i < scToggleTarget.length; ++i) {
            scToggleTarget[i].classList.remove(scToggleClass)
          }
          scToggleSwitch = false
          // console.log('Action:' + ++scToggleSctionCount)
        }
      }
      scToggleIsScroll = false // スクロールフラグをOFFに戻す
    }
    setTimeout(scrollFadein, scToggleFrameTime) // 次回の処理を登録
  }

  /*
        ######  ##       #### ########  ########
       ##    ## ##        ##  ##     ## ##
       ##       ##        ##  ##     ## ##
        ######  ##        ##  ##     ## ######
             ## ##        ##  ##     ## ##
       ##    ## ##        ##  ##     ## ##
        ######  ######## #### ########  ########
*/
  /*
         ##     ## ##     ##
         ###   ### ##     ##
         #### #### ##     ##
 ####### ## ### ## ##     ##
         ##     ##  ##   ##
         ##     ##   ## ##
         ##     ##    ###
*/
  if ($('#mv-slide')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('#mv-slide', {
      // init: false, // 自動で初期化しない（mvSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      //    simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
      fadeEffect: {
        // フェードオプション
        crossFade: true // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
      // pagination: {
      //   // ページャーオプション
      //   el: '.swiper-pagination--mv', // ページャーを呼び出す要素
      //   type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
      //   clickable: true // クリックでジャンプ可能にする
      // }
    })
  }
  $('.js-mvcta').on('click', function(e) {
    e.stopPropagation()
    e.preventDefault()
    location.href = $(this).attr('data-href')
  })
  /*
               ########  ########   #######
               ##     ## ##     ## ##     ##
               ##     ## ##     ## ##     ##
       ####### ########  ########  ##     ##
               ##        ##   ##   ##     ##
               ##        ##    ##  ##     ##
               ##        ##     ##  #######
*/
  if ($('.proBase-slide')[0]) {
    $('.proBase-slide').each(function() {
      // Swiperコンテナを検出したら実行
      // eslint-disable-next-line no-unused-vars
      const mvSwiper = new Swiper($(this), {
        // init: false, // 自動で初期化しない（mvSwiper.init()で初期化）
        effect: 'fade', // slide,fade,cube,coverflow
        speed: 500, // アニメ速度
        loop: true, // ループ
        preloadImages: false, // スライド内の画像を読み終えてから開始
        //    simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
        fadeEffect: {
          // フェードオプション
          crossFade: true // クロスフェード
        },
        autoplay: {
          // オートオプション
          delay: 4000, // 待機時間
          disableOnInteraction: false // 操作されたらオート解除
        },
        pagination: {
          // ページャーオプション
          el: $(this).find('.swiper-pagination--proBase'), // ページャーを呼び出す要素
          type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
          clickable: true // クリックでジャンプ可能にする
        }
      })
    })
  }

  /*
       ######## ########  ##     ## ##    ## ##    ##  #######
          ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
          ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
          ##    ########  ##     ## ## ## ## #####     #######
          ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
          ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
          ##    ##     ##  #######  ##    ## ##    ##  #######
*/
  function trunk8() {
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }

  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $(window).on('load resize ', function() {
      trunk8()
    })
  }

  /*
       ##     ##  #######  ########     ###    ##
       ###   ### ##     ## ##     ##   ## ##   ##
       ## ### ## ##     ## ##     ## ##     ## ##
       ##     ## ##     ## ##     ## ######### ##
       ##     ##  #######  ########  ##     ## ########
*/
  $(document).on('click ', '.js-modal--btn', function() {
    const name = $(this).data('modal')
    const id = $(this).data('id')
    const target = $('.js-modal--' + name)

    $('.js-modal').removeClass('active') // 他のモーダルを消す
    target.addClass('active')
    target.find('.js-modal--input').val(id)

    $('#modalOverlay').addClass('active')

    scrollLock('html,body', '#modalOverlay')
  })

  $(document).on('click ', '.js-modal--close', function() {
    $('.js-modal').removeClass('active')
    $('#modalOverlay').removeClass('active')

    scrollLock('html,body', '#modalOverlay')
  })

  /*
       ######## #### ########
           ##    ##  ##     ##
          ##     ##  ########
         ##      ##  ##
       ######## #### ##
*/
  /* global  AjaxZip3 */
  $('#zipsearch').on('click', function() {
    // 「zip」の郵便番号で見つけた住所を「address」に挿入
    AjaxZip3.zip2addr('zip1', 'zip2', 'pref', 'address1')
  })

  /*
       ########   #######     ###    ########  ########
       ##     ## ##     ##  ##   ##  ##     ## ##     ##
       ########  ##     ## ##     ## ########  ##     ##
       ##     ## ##     ## ######### ##   ##   ##     ##
       ########   #######  ##     ## ##     ## ########
*/
  if (document.getElementById('boardSelect')) {
    radioToggle()
  }
  $('.js-toggle--btn').on('change ', function() {
    radioToggle()
  })

  function radioToggle() {
    $('.js-toggle--btn:checked').each(function() {
      const name = '.js-toggle--' + $(this).data('name')
      const toggle = '.js-toggle--' + $(this).data('toggle')

      // 要素を消す
      $('.js-toggle--view' + name).addClass('js-hide')
      $('.js-toggle--view' + name + toggle).removeClass('js-hide')

      // 入力できなくする
      $('.js-toggle--input' + name).attr('disabled', 'disabled')
      $('.js-toggle--input' + name + toggle).removeAttr('disabled')

      // 選択肢を消す
      $('.js-toggle--select' + name)
        .children('.js-toggle--selectItem')
        .wrap('<span>')
      $('.js-toggle--selectItem' + name + toggle).unwrap()

      // ダミー要素を出す
      $('.js-toggle--dummy' + name)
        .next('.js-toggle--dummyItem')
        .remove()

      $('.js-toggle--dummy' + name + '.js-hide').after('<div class="js-toggle--dummyItem"></div>')
    })
  }

  /*
        ######  ######## ##       ########  ######  ########
       ##       ##       ##       ##       ##          ##
        ######  ######   ##       ######   ##          ##
             ## ##       ##       ##       ##          ##
        ######  ######## ######## ########  ######     ##
*/
  $('.js-selectEvent').on('change ', function() {
    // 選択した要素をキャッシュ
    const target = $(this).data('target')
    const select = $(this)
      .find('option:selected')
      .data('item')
    const item = $(target).find('.js-selectEvent--item')

    item.addClass('js-hide')
    $(target)
      .find('.js-selectEvent--' + select)
      .removeClass('js-hide')
  })

  /*
        ######  ##     ## ########  ######  ##    ##
       ##       ##     ## ##       ##       ##  ##
       ##       ######### ######   ##       #####
       ##       ##     ## ##       ##       ##  ##
        ######  ##     ## ########  ######  ##    ##
*/
  $('.js-checkEvent').on('change ', function() {
    // 選択した要素をキャッシュ
    const target = $(this).data('target')
    const select = $(this).data('item')
    const item = $(target).find('.js-checkEvent--item')

    item.addClass('js-hide')
    $(target)
      .find('.js-checkEvent--' + select)
      .removeClass('js-hide')
  })

  /*
       ######## #### ##       ########
       ##        ##  ##       ##
       ######    ##  ##       ######
       ##        ##  ##       ##
       ##       #### ######## ########
*/
  // ファイルアップロードUIのカスタム
  $('.js-customFile').on('change', function() {
    const file = $(this).prop('files')[0]
    const target = $(this).data('target')
    $('.js-customFile--' + target).text(file.name)
  })

  /*
 ########  #######   ######    ######   ##       ########
    ##    ##     ## ##    ##  ##    ##  ##       ##
    ##    ##     ## ##        ##        ##       ##
    ##    ##     ## ##   #### ##   #### ##       ######
    ##    ##     ## ##    ##  ##    ##  ##       ##
    ##    ##     ## ##    ##  ##    ##  ##       ##
    ##     #######   ######    ######   ######## ########
*/
  if (document.getElementsByClassName('js-checkToggle')[0]) {
    formToggle()
    $(document).on('change ', '.js-checkToggle-check', function() {
      formToggle()
    })
  }
  function formToggle() {
    const checkToggle = $('.js-checkToggle')
    checkToggle.removeClass('active')
    checkToggle.find('input,select').attr('disabled', 'disabled')
    $('.js-checkToggle-check:checked').each(function() {
      const target = $(this).data('toggle')
      $('.js-checkToggle--' + target).addClass('active')
      $('.js-checkToggle--' + target)
        .find('input,select')
        .removeAttr('disabled')
    })
  }

  /*
       ########  ######## ########  ##     ##  ######
       ##     ## ##       ##     ## ##     ## ##    ##
       ##     ## ##       ##     ## ##     ## ##
       ##     ## ######   ########  ##     ## ##   ####
       ##     ## ##       ##     ## ##     ## ##    ##
       ##     ## ##       ##     ## ##     ## ##    ##
       ########  ######## ########   #######   ######
*/
  // デバッグ用処理
  if (location.hash === '#--debug-login') {
    // ハッシュを検出したら実行
    const body = document.getElementById('body')
    body.classList.remove('state-guest')
    body.classList.add('state-login')
  }

  // デバッグ用処理
  if (location.hash.match(/#--debug-state-/)) {
    // ハッシュを検出したら実行
    const debugVal = location.hash.replace(/#--debug-state-/, '')
    $('.statePoint')
      .removeClass('state-make')
      .addClass('state-' + debugVal)
  }

  // デバッグ用処理
  if (location.hash.match(/#--debug-modal-/)) {
    // ハッシュを検出したら実行
    const name = location.hash.replace(/#--debug-modal-/, '')
    const target = $('.js-modal--' + name)

    target.addClass('active')

    $('#modalOverlay').addClass('active')

    scrollLock('html,body', '#modalOverlay')
  }
})
